import { DescriptionPage_ProductVariant as ProductVariant } from '__generated__/graphql-types';

import routeConfig from 'bundles/unified-description-page-common/constants/routeConfig';

const getProductPath = (productVariant: ProductVariant) => {
  switch (productVariant) {
    case ProductVariant.ProfessionalCertificate:
    case ProductVariant.ExternalCertificate:
      return routeConfig.PROFESSIONAL_CERTIFICATES.pathname;
    default:
      return routeConfig.SPECIALIZATIONS.pathname;
  }
};

export const getConsumerRouteForSpecializationProducts = (
  productVariant: ProductVariant,
  slug: string,
  search?: string
) => {
  let url = `/${getProductPath(productVariant)}/${slug}`;

  if (search) {
    url += `${search}`;
  }

  return url;
};

export const getEnterpriseRouteForSpecializationProducts = (
  productVariant: ProductVariant,
  slug: string,
  programSlug: string,
  search?: string
) => {
  let url = `/programs/${programSlug}/${getProductPath(productVariant)}/${slug}`;

  if (search) {
    url += `${search}`;
  }

  return url;
};
